import React, { useState } from "react";
import { AddCustomerForm } from "../../core/Services";
import { useToast } from "@chakra-ui/react";
import Form from "./components/Form";

export default function CustomerQuotation() {
  const toast = useToast();

  const [form, setForm] = useState({
    name: "",
    surname: "",
    email: "",
    phone: "",
    description: "",
  });
  const [selectedUrgency, setSelectedUrgency] = useState(null);
  const [selectedCounrtyPhone, setSelectedCounrtyPhone] = useState(null);
  const [selectedCookies, setSelectedCookies] = useState([]);
  const [errors, setErrors] = useState({});

  // email kontrolü
  const checkValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // kayıt işlemi
  const handleSave = () => {
    AddCustomerForm(form, selectedUrgency, selectedCookies, selectedCounrtyPhone, [])
      .then((response) => {
        if (response.message === "Hata") {
          toast({
            title: "Hata",
            description: "Bu bilgilerle daha önce kayıt alınmış.",
            status: "error",
            duration: 3000,
            position: "top-right",
            isClosable: true,
          });
        } else {
          setForm({
            name: "",
            surname: "",
            email: "",
            phone: "",
            description: "",
          });
          setSelectedUrgency("");
          setSelectedCookies("");
          setSelectedCounrtyPhone("");

          toast({
            title: "Başarılı",
            description: "Talebiniz başarıyla kaydedildi.",
            status: "success",
            duration: 3000,
            position: "top-right",
            isClosable: true,
          });
        }
      })
      .catch((error) => {
        console.error("Backend'e gönderme hatası:", error);
        toast({
          title: "Hata",
          description: "Veri gönderilirken bir hata oluştu.",
          status: "error",
          duration: 3000,
          position: "top-right",
          isClosable: true,
        });
      });
  };

  // form validasyonu
  const onSubmitForm = () => {
    const inputErrors = {};
    if (!form.name) inputErrors.name = "Ad alanı boş bırakılamaz";
    if (!form.surname) inputErrors.surname = "Soyad alanı boş bırakılamaz";
    if (!form.email) {
      inputErrors.email = "E-posta alanı boş bırakılamaz";
    } else if (!checkValidEmail(form.email)) {
      inputErrors.email = "Geçersiz e-posta adresi";
    }
    if (!form.phone) {
      inputErrors.phone = "Telefon alanı boş bırakılamaz";
    } else if (!/^\d{10}$/.test(form.phone)) {
      inputErrors.phone = "Telefon numarası 10 haneli olmalıdır";
    }
    if (!selectedUrgency) {
      inputErrors.selectedUrgency = "Aciliyet seçilmelidir";
    }
    const cookieArray = Array.isArray(selectedCookies) ? selectedCookies : [];
    const idCookieSelected = cookieArray?.find((cookie) => cookie === "0");
    if (!idCookieSelected) {
      inputErrors.selectedCookies = "Lütfen Çerez Politikasını onaylayınız.";
    }

    if (Object.keys(inputErrors).length > 0) {
      setErrors(inputErrors);
    } else {
      setErrors({});
      handleSave();
    }
  };

  return (
    <div className="p-6">
      {/* Üst Bilgi Alanı */}
      <h1 className="text-3xl font-bold text-center mb-4">
        EK Dizayn | Teklif Formu
      </h1>
      <p className="text-center mb-6 text-gray-300">
        Aşağıdaki formu doldurarak teklif talebinizi bize iletebilirsiniz.
      </p>

      {/* Form */}
      <div className="card shadow-md p-6">
        <Form
          selectedUrgency={selectedUrgency}
          setSelectedUrgency={setSelectedUrgency}
          form={form}
          errors={errors}
          setErrors={setErrors}
          setForm={setForm}
          selectedCounrtyPhone={selectedCounrtyPhone}
          setSelectedCounrtyPhone={setSelectedCounrtyPhone}
          selectedCookies={selectedCookies}
          setSelectedCookies={setSelectedCookies}
        />

        <div className="flex justify-end mt-4">
          <button
            onClick={onSubmitForm}
            className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
          >
            Gönder
          </button>
        </div>
      </div>

      {/* Teklif Süreci */}
      <section className="mt-10">
        <h2 className="text-2xl font-semibold mb-2">Teklif Süreci Nasıl İşler?</h2>
        <ol className="list-decimal pl-6 space-y-1">
          <li>Formu doldurup bize gönderirsiniz.</li>
          <li>Ekibimiz 24 saat içinde size dönüş yapar.</li>
          <li>İhtiyacınız netleştirilir ve size özel teklif hazırlanır.</li>
          <li>Onayınız sonrası çalışma başlatılır.</li>
        </ol>
      </section>

      {/* SSS */}
      <section className="mt-10">
        <h2 className="text-2xl font-semibold mb-2">Sıkça Sorulan Sorular</h2>
        <div className="space-y-2">
          <details>
            <summary>Teklif almak ücretli mi?</summary>
            <p>Hayır, teklif alma süreci tamamen ücretsizdir.</p>
          </details>
          <details>
            <summary>Ne kadar sürede teklif hazırlanır?</summary>
            <p>Genellikle 1-2 iş günü içinde size dönüş yapılır.</p>
          </details>
          <details>
            <summary>Form doldurduktan sonra nasıl iletişim kurulur?</summary>
            <p>Belirttiğiniz telefon veya e-posta üzerinden size ulaşıyoruz.</p>
          </details>
        </div>
      </section>
    </div>
  );
}
